const e = "en-US";
export { e as DEFAULT_LOCALE };
